import React, { useState } from "react";
import Collapse from "@mui/material/Collapse";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const CollapseSection = ({
  title,
  children,
  defaultOpen = false,
  headerBg = "rgba(52, 73, 94, 0.94)",
  headerColor = "#fff",
  iconColor = "#fff",
  style = {},
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div style={{ marginBottom: "1rem", marginTop: `1rem` }}>
      {/* Header */}
      <div
        className="collapse-header"
        onClick={() => setOpen(!open)}
        aria-controls="collapse-content"
        aria-expanded={open}
        style={{
          background: headerBg,
          padding: "0.25rem 1.25rem",
          borderRadius: "0.25rem",
          fontWeight: "600",
          display: "flex",
          cursor: "pointer",
          justifyContent: "space-between",
          alignItems: "center",
          color: "white",
          ...style,
        }}
      >
        <span style={{ fontSize: 16, color: "white" }}>{title}</span>
        {open ? <RemoveIcon sx={{ color: iconColor }} /> : <AddIcon sx={{ color: iconColor }} />}
      </div>

      {/* Content */}
      <Collapse in={open}>
        <div
          id="collapse-content"
          style={{
            marginTop: 12,
            paddingLeft: 12,
            paddingRight: 12,
          }}
        >
          {children}
        </div>
      </Collapse>
    </div>
  );
};

export default CollapseSection;
